import { useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";

interface DepositoryType {
  id: number;
  name: string;
}

export function useGetDepositories(enabled = true) {
  return useQuery({
    queryKey: ["depositories"],
    queryFn: async () => {
      return axiosInstance.get("/depositories").then((res) => res.data);
    },
    select: (data: DepositoryType[]) =>
      data.map((d) => ({ label: d.name, value: d.id })),
    staleTime: 1000 * 60 * 60,
    enabled,
  });
}
